<div (dblclick)="!selectionMode ? openTaskDetails() : ''"
     [ngClass]="{'bg-white': !selectionMode || selectionMode && selected,
     'bg-gray-100': selectionMode && !selected}"
     class="hover:cursor-grab rounded-lg border border-gray-200 flex flex-col p-4 w-full gap-4 text-gray">
    <div class="flex flex-row justify-between items-center w-full">
      @if (selectionMode) {
        <input #checkbox (change)="selected = !selected" [checked]="selected"
               class="w-4 h-4 rounded text-green-600 checked:bg-green indeterminate:bg-green indeterminate:hover:bg-green focus:ring-[none] bg-gray-100 border-gray-300"
               type="checkbox">
      }
      <div class="text-base font-medium overflow-hidden w-full line-clamp-2">
        {{ task.title }}
      </div>
      @if (!selectionMode) {
        <div [bicDropdownTrigger]="dropdown" class="hover:cursor-pointer" >
          <fa-icon
            [icon]="faEllipsisVertical"
            class="w-4 h-4 flex items-center justify-center [&>svg]:w-full [&>svg]:h-full [&>svg]:max-w-none"></fa-icon>
        </div>
        <bic-dropdown #dropdown [dropdownPlacement]="'bottom-start'">
          <bic-dropdown-element (onClick)="openTaskDetails(); dropdown.hide()">
            <div class="flex flex-row text-sm gap-2">
              <fa-icon [icon]="faArrowUpRightFromSquare"></fa-icon>
              <span>Öffnen</span>
            </div>
          </bic-dropdown-element>
          <bic-dropdown-element (onClick)="duplicate(); dropdown.hide()">
            <div class="flex flex-row text-sm gap-3 text-gray-700">
              <fa-icon [icon]="faCopy" class="text-gray-700"></fa-icon>
              <span>Duplizieren</span>
            </div>
          </bic-dropdown-element>
          <bic-dropdown-element (click)="isOpen = true; dropdown.hide()">
            <div class="flex flex-row text-sm gap-2 text-red">
              <fa-icon [icon]="faTrash" class="text-red"></fa-icon>
              <span>Löschen</span>
            </div>
          </bic-dropdown-element>
        </bic-dropdown>
      }

    </div>
  <!--    <div class="flex flex-row w-full gap-4 break-words">-->
  <!--      &lt;!&ndash;      <div class="flex w-[40%] justify-center items-center rounded-lg bg-gray-700">&ndash;&gt;-->
  <!--      &lt;!&ndash;        <fa-icon [icon]="faIfc" class="text-white text-[32px]"></fa-icon>&ndash;&gt;-->
  <!--      &lt;!&ndash;      </div>&ndash;&gt;-->
  <!--      <div class="flex w-[100%] text-sm line-clamp-3 min-h-[64px]">-->
  <!--        {{ task.description }}-->
  <!--      </div>-->
  <!--    </div>-->
  <div class="flex flex-col">
    <div #metaRow class="flex flex-row items-center w-full gap-4 overflow-hidden">
      <div [tooltip]="'Priorität'" class="flex flex-row items-center flex-shrink-0">
        <fa-icon [icon]="faCircleSmall" [ngClass]="{
          'text-red': task.priority === 'HIGH',
          'text-gray-500': task.priority === 'NORMAL',
          'text-green': task.priority === 'LOW'
          }" class="text-[1.6rem] flex items-center"></fa-icon>
        <span class="text-gray whitespace-nowrap text-sm pl-2">{{ task.priority! | priority }}</span>
      </div>
      <div [tooltip]="'Kommentare'" class="flex flex-row items-center flex-shrink-0">
        <fa-icon [icon]="faMessages" class="text-[0.8rem]"></fa-icon>
        <span class="whitespace-nowrap text-sm pl-2">{{ task.comment?.length }}</span>
      </div>
      @if (task.dueDate) {
        <div [tooltip]="getDaysUntilDueDate(task.dueDate) < 0 ? 'überfällig seit' : 'Fällig in'"
             class="flex flex-row items-center flex-shrink-0">
          <fa-icon [icon]="faCalendarDays" class="text-[0.8rem]"
                   [ngClass]="{'text-red': getDaysUntilDueDate(task.dueDate) < 0}"></fa-icon>
          <span class="whitespace-nowrap text-sm pl-2"
                [ngClass]="{'text-red': getDaysUntilDueDate(task.dueDate) < 0}">
            {{ getAbsoluteValue(getDaysUntilDueDate(task.dueDate)) }}T
          </span>
        </div>
      }

      @if (task.assignedToUser) {
        <div class="ml-auto flex flex-row items-center flex-shrink-0"
             [tooltipDirection]="'left'"
             [tooltip]="$safeNavigationMigration(task.assignedToUser?.firstName) + ' ' + $safeNavigationMigration(task.assignedToUser?.lastName)"
             [tooltipSubtext]="($safeNavigationMigration(task.assignedToUser?.roleInProjects![this.task.projectId!]?.name) | roleAndPrivileges)">
          @if (task.assignedToUser?.profileImage && !task.assignedToUser?.profileImage?.toLowerCase()?.includes('defaultimages/profile.png')) {
            <img alt="Verantwortlicher" class="w-6 h-6 rounded-full border border-gray-200 object-cover flex-shrink-0"
                 (error)="task.assignedToUser.profileImage = undefined"
                 src="{{task.assignedToUser?.profileImage}}">
          } @else {
            <div
              class="relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-gray-100 rounded-full border border-gray-200 flex-shrink-0">
                <span
                  class="font-medium text-[0.625rem] text-green">{{ task.assignedToUser?.firstName?.charAt(0)?.toUpperCase() }}{{ task.assignedToUser?.lastName?.charAt(0)?.toUpperCase() }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>


</div>

@if (isOpen) {
<bic-popup (close)="isOpen = false"
  [title]="'Task löschen?'"
  [hasBackdrop]="true" class="w-[800px]">

  <div bicPopupContent class="flex flex-col gap-5 font-normal">
    <p>
      Möchten Sie die Task
      <span class="font-medium">{{ task?.title }}</span>
      wirklich löschen?
    </p>
    <p class="font-medium">Diese ist nachträglich nicht wiederherstellbar!</p>
  </div>

  <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
    <bic-button (onClick)="isOpen = false" buttonType="white">
      Abbrechen
    </bic-button>
    <bic-button (onClick)="isOpen = false; deleteTask()" buttonType="red">Löschen</bic-button>
  </div>
</bic-popup>
}
